import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
    useMemo,
} from "react";
import style from "./AdminAddBulkStockNew.module.css";
import Select from "react-select";
import { FaPlus, FaTrash } from "react-icons/fa";
import "./AddBulkStock.css";



export default function AddStockGridSection({ fields, categoriesData, filteredProducts,
    handlegriddropdown, filteredDesigns, filteredPurity, collectionmainlist,
    allPacketNumbers, boxData, allSku, handlegridinput, selectedImages2, AddedProducts, handleadditem, filteredSupplier, setPopupVisible, handlepopup, filteredsku }) {


    const [previousFields, setPreviousFields] = useState([]);

    useEffect(() => {
        if (fields !== previousFields) {

            setPreviousFields(fields); // Update previousFields to trigger re-render on change
        }
    }, [fields]); // Re-run when 'fields' prop changes



    const renderDropdownOptions = (fieldKey, rowIndex) => {
        switch (fieldKey) {
            case "CategoryId":
                return categoriesData.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.CategoryName}
                    </option>
                ));
            case "ProductId":
                return filteredProducts('grid', rowIndex)?.map((x, y) => (
                    <option key={y} value={parseInt(x.Id)}>
                        {x.ProductName}
                    </option>
                ));
            case "PurityId":
                return filteredPurity('grid', rowIndex)?.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.PurityName}
                    </option>
                ));
            case "DesignId":
                return filteredDesigns('grid', rowIndex)?.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.DesignName}
                    </option>
                ));
            case "CollectionId":
                return collectionmainlist?.map((x, y) => (
                    <option key={y} value={x.Collection.Id}>
                        {x.Collection.CollectionName}
                    </option>
                ));
            case "PacketId":
                return allPacketNumbers.map((x, y) => (
                    <option key={y} value={parseInt(x.Id)}>
                        {x.PacketName}
                    </option>
                ));
            case "BoxId":
                return boxData.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.BoxName}
                    </option>
                ));
            case "mainstone":
                return selectedsku?.SKUStoneMain?.map((stone, index) => (
                    <option key={index} value={stone.Id}>
                        {stone.StoneMainName}
                    </option>
                ));
            case "WeightCategory":
                return selectedWeights.map((weight, index) => (
                    <option key={index} value={weight}>
                        {weight}
                    </option>
                ));
                case "VendorId":
                return filteredSupplier.map((v, index) => (
                    <option key={index} value={v.Id}>
                        {v.VendorName}
                    </option>
                ));
                case "SKU":
                return filteredsku.map((s, index) => (
                    <option key={index} value={s.Id}>
                        {s.StockKeepingUnit}
                    </option>
                ));
            default:
                return null;
        }
    };


    const renderDropdownOptions1 = (fieldKey, rowindex) => {
        switch (fieldKey) {
            case "CategoryId":
                return categoriesData.map((x) => ({
                    value: x.Id,
                    label: x.CategoryName,
                }));
            case "ProductId":
                return filteredProducts("grid", rowindex).map((x) => ({
                    value: parseInt(x.Id),
                    label: x.ProductName,
                }));
            case "PurityId":
                return filteredPurity("grid", rowindex).map((x) => ({
                    value: x.Id,
                    label: x.PurityName,
                }));
            case "DesignId":
                return filteredDesigns("grid", rowindex).map((x) => ({
                    value: x.Id,
                    label: x.DesignName,
                }));
            case "CollectionId":
                return collectionmainlist?.map((x) => ({
                    value: x.Collection.Id,
                    label: x.Collection.CollectionName,
                }));
            case "PacketId":
                return allPacketNumbers.map((x) => ({
                    value: parseInt(x.Id),
                    label: x.PacketName,
                }));
            case "BoxId":
                return boxData.map((x) => ({
                    value: x.Id,
                    label: x.BoxName,
                }));
            case "mainstone":
                return selectedsku?.SKUStoneMain?.map((stone) => ({
                    value: stone.Id,
                    label: stone.StoneMainName,
                }));
            case "WeightCategory":
                return selectedWeights.map((weight) => ({
                    value: weight,
                    label: weight,
                }));
            default:
                return [];
        }
    };

    console.log('checking products ');

    // const handlepopup =()=>{
    //     setPopupVisible()
    // }



    return (
        <div
            style={{ marginTop: "0px" }}
            className={style.tablecontainer}
        >

            <div className={style.tablescroll}>
                <table>
                    <thead>
                        <tr>
                            {fields
                                .filter(
                                    (field) => field.place === 'grid'
                                        && field.visibility !== 'Hidden'
                                        && field.IsVisible !== 'Hidden')
                                .sort((a, b) => a.priority - b.priority)

                                .map((field) => (
                                    <th
                                        key={field.key}
                                        className={style.AddStockthead}
                                    >
                                        {/* {field.label || field.key}  */}
                                        {field.key === "ActionPlus" ? (
                                            <>
                                                {/* Action */}
                                                <FaPlus
                                                    style={{
                                                        marginLeft: "8px",
                                                        cursor: "pointer",
                                                        height: "20px",
                                                        width: "20px",
                                                        color: "#4CAF50", // Customize icon color
                                                    }}
                                                    onClick={() => {
                                                        handleadditem();
                                                        // Add row functionality here
                                                    }}
                                                />
                                            </>
                                        ) : (
                                            field.label || field.key
                                        )}
                                    </th>
                                ))}

                        </tr>
                    </thead>
                    <tbody>
                        {AddedProducts?.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {fields
                                    .filter(
                                        (field) =>
                                            field.place === "grid" &&
                                            field.visibility !== "Hidden" &&
                                            field.IsVisible !== "Hidden"
                                    )
                                    .sort((a, b) => a.priority - b.priority)
                                    .map((field, columnIndex) => {
                                        // let value = field.key === "VendorIdd"
                                        //     ? row["VendorName"] || ""
                                        //     : row[field.key] || "";

                                        let value = row[field.key] || "";

                                        const options = renderDropdownOptions1(field.key, rowIndex);

                                        console.log('checking options ', '   ', field.key);
                                        let pvalue = 0; // Default length
                                        if (['Stones', 'Diamond', 'Images'].includes(field.key)) {
                                            pvalue = Array.isArray(row[field.key]) ? row[field.key].length : 0;
                                        }

                                        return (
                                            <td key={columnIndex}>
                                                {field.type === "dropdown" ? (
                                                    <select
                                                        className={style.adminAddCategoryMainBox2select}
                                                        value={value}
                                                        onChange={(e) => handlegriddropdown(field.key, e, rowIndex)}
                                                    >
                                                        <option value="">Select</option>
                                                        {renderDropdownOptions(field.key, rowIndex)}
                                                    </select>
                                                ) : field.type === "dropdown1" ? (
                                                    <div className={
                                                        style.adminAddCategoryMainBox2itemfield
                                                    }>


                                                        <Select
                                                            options={options}
                                                            value={options.find((option) => option.value === row[field.key]) || null}
                                                            onChange={(selectedOption) =>
                                                                handlegriddropdown(field.key, selectedOption, rowIndex)
                                                            }

                                                            isSearchable={true}
                                                            placeholder={field.label}
                                                            className={style.adminAddCategoryMainBox2select}
                                                            classNamePrefix="adminAddCategoryMainBox2select"
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    border: "1px solid #ddd",
                                                                    borderRadius: "4px",
                                                                }),
                                                                dropdownIndicator: (provided) => ({
                                                                    ...provided,
                                                                    fontSize: 12, // Adjust the size of the down arrow
                                                                    padding: 5, // Adjust padding to make the arrow smaller
                                                                }),
                                                                indicatorSeparator: (provided) => ({
                                                                    ...provided,
                                                                    display: 'none', // Optionally remove the separator between the input and arrow
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                )

                                                    : field.type === "inputnumber" ||
                                                        field.type === "inputtext" ||
                                                        field.type === "inputdecimal" ? (
                                                        <input
                                                            style={{ border: "1px solid #ddd" }}
                                                            step={field.type === "inputdecimal" ? "0.01" : "1"}
                                                            value={value}
                                                            className={style.AddStockinput}
                                                            onChange={
                                                                (e) =>
                                                                    handlegridinput(


                                                                        field.key,
                                                                        e,
                                                                        rowIndex
                                                                    ) // Handle input change
                                                            }
                                                            disabled={
                                                                field.visibility === "ReadOnly" ||
                                                                field.IsVisible === "ReadOnly"
                                                            }
                                                            type={
                                                                field.type === "inputtext"
                                                                    ? "text"
                                                                    : field.type === "inputnumber"
                                                                        ? "number"
                                                                        : "text"
                                                            }
                                                            onInput={(e) => {
                                                                if (field.type === "inputnumber") {
                                                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                                                } else if (field.type === "inputdecimal") {
                                                                    e.target.value = e.target.value
                                                                        .replace(/[^0-9.]/g, "")
                                                                        .replace(/(\..*?)\..*/g, "$1");
                                                                }
                                                            }}
                                                        />
                                                    ) : field.type === "Icon" ? (
                                                        <div key={field.key}>
                                                            <FaTrash
                                                                style={{
                                                                    marginLeft: "8px",
                                                                    cursor: "pointer",
                                                                    // color: '#4CAF50', // Customize icon color
                                                                }}
                                                                onClick={() => {
                                                                    if (
                                                                        rowIndex ===
                                                                        AddedProducts.length - 1
                                                                    ) {
                                                                        // Add your click logic here
                                                                        console.log("last item");
                                                                        const updatedProducts =
                                                                            AddedProducts.filter(
                                                                                (_, index) =>
                                                                                    index !== rowIndex
                                                                            );
                                                                        setAddedProducts(
                                                                            updatedProducts
                                                                        ); // Update the state
                                                                    } else {
                                                                        console.log("other item");
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    ) : field.type === "popup" ? (
                                                        <div className={style.inputgroup}>
                                                            <input
                                                                id="stone-input"
                                                                type="text"
                                                                value={
                                                                    pvalue
                                                                }
                                                                // onChange={handleImageChange2}
                                                                style={{
                                                                    margin: 0,
                                                                    border: "1px solid #ddd",
                                                                }}
                                                                className={style.inputfield}
                                                                placeholder=""


                                                            />
                                                            <button
                                                                className={style.addbutton}

                                                                onClick={() => {
                                                                    if (field.key === 'Stones') {
                                                                        // if(AddedProducts[rowIndex].stone)
                                                                        // handleadditem();
                                                                        // setPopupVisible('stones')
                                                                        handlepopup('stones', 'bottom', rowIndex);
                                                                    } else if (field.key === 'DButton') {
                                                                        // setPopupVisible('diamonds')
                                                                        handlepopup('diamond', 'bottom', rowIndex);
                                                                    }
                                                                }}
                                                            >
                                                                +
                                                            </button>
                                                        </div>
                                                    ) :


                                                        (
                                                            <div>

                                                            </div>
                                                        )
                                                }
                                            </td>
                                        );
                                    })}
                            </tr>
                        ))}
                    </tbody>
                </table>


            </div>

        </div>

    )



}

